import { useEffect, useRef, useState } from "react";
import { Globe } from "lucide-react";
import { useLang, LANGS } from "@/i18n";

export default function LangSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="lang-switcher-button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 text-sm text-slate-300 transition-colors duration-300 hover:text-gold"
        aria-label="Change language"
      >
        <Globe className="h-4 w-4" />
        <span className="font-mono text-xs uppercase tracking-widest">{lang}</span>
      </button>
      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute end-0 top-full z-50 mt-3 w-44 overflow-hidden rounded-xl border border-white/10 bg-obsidian-card shadow-2xl"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`block w-full px-5 py-3 text-start text-sm transition-colors ${
                lang === l.code ? "bg-gold/10 text-gold" : "text-slate-300 hover:bg-white/5 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
